import React, { useEffect, useState } from 'react';
import { type QnAStateType, selectors } from '@uber/react-qna-lib';
import { styled } from 'baseui';
import { Notification } from 'baseui/notification';
import { Spinner } from 'baseui/spinner';
import { useAPIProvider } from '../../hooks/use-api-provider';
import Questionnaire from '../../questionnaire-panel/questionnaire';
import type { AnswerT } from '../../types/types';
import { convertAnswersToUserAnswerMap } from '../utils';
const SpinnerContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center'
});
type PropsT = {
  questionnaireId: string;
  answers?: AnswerT;
  isQuestionnaireComposable?: boolean;
  onChange: (isAllAnswered: boolean, answers?: AnswerT) => void;
  questionFilterFn?: (x: QnAStateType) => QnAStateType;
};
function QuestionnairePanel({
  questionnaireId,
  answers,
  isQuestionnaireComposable,
  onChange,
  questionFilterFn
}: PropsT) {
  const [isLoading, setLoading] = useState(true);
  const [questionnaire, setQuestionnaire] = useState<QnAStateType | null>(null);
  const [errors, setErrors] = useState([]);
  const {
    fetchQuestionnaire
  } = useAPIProvider();
  useEffect(() => {
    (async () => {
      if (!questionnaire) {
        try {
          let response = await fetchQuestionnaire(questionnaireId);
          response = questionFilterFn ? questionFilterFn(response) : response;
          response.answers = {};
          if (answers) {
            response = {
              ...response,
              answers: convertAnswersToUserAnswerMap(response, answers)
            };
          }
          setQuestionnaire(response);
          // Emitting initial state of questionnaire
          onChange(!selectors.hasValidationErrors(response));
        } catch (e) {
          onChange(false);
          // @ts-expect-error missing null check
          setErrors([`${e}`]);
        }
        setLoading(false);
      }
    })();
  }, [fetchQuestionnaire, questionnaireId, onChange, answers, questionnaire, questionFilterFn]);
  if (errors.length > 0) {
    return <Notification>
        {() => <>
            Failed fetching questionnaire:
            {errors.map(error => <div key={error}>{error}</div>)}
          </>}
      </Notification>;
  }
  if (isLoading || !questionnaire) {
    return <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>;
  }
  return <Questionnaire questionnaire={questionnaire} onChange={onChange} isQuestionnaireComposable={isQuestionnaireComposable} />;
}
export default QuestionnairePanel;